/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import Slider from "@mui/material/Slider";
import { FaPauseCircle, FaPlayCircle } from "react-icons/fa";
import { IoClose, IoPlaySkipBack, IoPlaySkipForward } from "react-icons/io5";
import { RiForward5Fill, RiReplay5Fill } from "react-icons/ri";
import { AUDIO_PLAYER, COLORS, ICON_ORANGE_COLOR, PLAY_PAUSE_ICON_COLOR } from "~/utils/constant";

import { motion } from "framer-motion";
import { memo, useEffect, useRef, useState, useCallback } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa6";
import { useIsMobile } from "~/hook/use-mobile";
import { useFontStyle } from "~/hook/useFontStyle";
import { formatTime } from "~/lib/helperFuncation/getFormateTime";
import { touchVariants } from "~/lib/motion-obj";
import {
  addAudioQueue,
  addToCurrentAudio,
  changeDesktopAccordionStatus,
  changeIsAudioPlayState,
  changeIsPlayingState,
  setCurrentAudioTime,
  setDuration,
  setIsAnnakutAudioPlaying,
  setPlayAllAudio,
  setPlaybackSpeed,
  setProgress,
  setShowDeleteConfirmation,
} from "~/lib/store/slice/audioSlice";
import { onPauseVideo, setShowThumbnail } from "~/lib/store/slice/youtubePlayerSlice";
import { useAppDispatch, useAppSelector } from "~/lib/store/store";
import { cn } from "~/lib/utils";
import { Button } from "../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { removeSession } from "~/lib/helperFuncation/sessionStorageService";
import { useSearchParams } from "react-router";

const playBackSpeedArray = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];

function AudioPlayerPopUp({ isContent = false }: { isContent?: boolean }) {
  // Separate static state from frequently-changing state
  const staticState = useAppSelector((state) => ({
    isPlaying: state.nityNiyam.isPlaying,
    currentAudio: state.nityNiyam.currentAudio,
    audioQueue: state.nityNiyam.audioQueue,
    duration: state.nityNiyam.duration,
    desktopAccordionShow: state.nityNiyam.desktopAccordionShow,
    playbackSpeed: state.nityNiyam.playbackSpeed,
    showDeleteConfirmation: state.nityNiyam.showDeleteConfirmation,
    media_type_control: state.nityNiyam.media_type_control,
    isVideoPlay: state.youtubeVideo.isPlaylist,
  }));

  const { currentTime, progress } = useAppSelector((state) => ({
    currentTime: state.nityNiyam.currentTime,
    progress: state.nityNiyam.progress,
  }));

  const {
    isPlaying,
    currentAudio,
    audioQueue,
    duration,
    desktopAccordionShow,
    playbackSpeed,
    showDeleteConfirmation,
    media_type_control,
    isVideoPlay,
  } = staticState;

  const dispatch = useAppDispatch();
  const { normalInter } = useFontStyle();
  const isMobile = useIsMobile();
  const [searchParams] = useSearchParams();

  const [showRemainingTime, setShoeRemainingTime] = useState(true);
  const sliderRef = useRef(null);
  const [showHoverTooltip, setShowHoverTooltip] = useState(false);
  const [hoverTime, setHoverTime] = useState(0);
  const [tooltipX, setTooltipX] = useState(0);
  const [showMobileSeekTooltip, setShowMobileSeekTooltip] = useState(false);
  const [mobileTooltipTime, setMobileTooltipTime] = useState(0);
  const [mobileTooltipX, setMobileTooltipX] = useState(0);

  // NEW: States for tracking drag
  const [isDragging, setIsDragging] = useState(false);
  const [dragTime, setDragTime] = useState(0);

  const handleNextAudio = useCallback(() => {
    dispatch(setProgress(0));
    const currentAudioIndex = audioQueue?.findIndex((item) => item.id === currentAudio?.id);
    if (currentAudioIndex !== undefined && currentAudioIndex !== -1) {
      const nextAudio = audioQueue?.[(currentAudioIndex + 1) % audioQueue.length];
      dispatch(changeIsPlayingState(true));
      if (nextAudio) {
        dispatch(addToCurrentAudio(nextAudio));
      }
      sessionStorage.setItem(AUDIO_PLAYER.CURRENT_AUDIO, JSON.stringify(nextAudio));
    }
  }, [audioQueue, currentAudio?.id, dispatch]);

  const handlePreviousAudio = useCallback(() => {
    dispatch(setProgress(0));
    const currentAudioIndex = audioQueue?.findIndex((item) => item.id === currentAudio?.id);

    if (currentAudioIndex !== undefined && currentAudioIndex !== -1) {
      const previousAudio = audioQueue?.[(currentAudioIndex - 1 + audioQueue.length) % audioQueue.length];
      dispatch(changeIsPlayingState(true));
      if (previousAudio) {
        dispatch(addToCurrentAudio(previousAudio));
      }
      sessionStorage.setItem(AUDIO_PLAYER.CURRENT_AUDIO, JSON.stringify(previousAudio));
    }
  }, [audioQueue, currentAudio?.id, dispatch]);

  const handleAudioPlayerClose = useCallback(() => {
    // dispatch(changeIsPlayingState(false));
    dispatch(changeDesktopAccordionStatus(false));
    dispatch(setShowDeleteConfirmation(true));
  }, [dispatch]);

  const handleAudioPlayerCloseWithConfirmation = useCallback(() => {
    dispatch(setShowDeleteConfirmation(false));
    dispatch(changeIsAudioPlayState(false));
    dispatch(addAudioQueue(null));
    dispatch(addToCurrentAudio(null));
    dispatch(setCurrentAudioTime(0));
    dispatch(changeIsPlayingState(false));
    dispatch(setPlayAllAudio(false));

    if (!isVideoPlay) {
      dispatch(setShowThumbnail(true));
    }

    removeSession(AUDIO_PLAYER.AUDIO_QUEUE);
    removeSession(AUDIO_PLAYER.CURRENT_AUDIO);
    removeSession(AUDIO_PLAYER.IS_PLAY);
    removeSession(AUDIO_PLAYER.CURRENT_TIME);
    removeSession(AUDIO_PLAYER.MEDIA_TYPE_CONTROL);
    removeSession(AUDIO_PLAYER.IS_AUDIO_PLAYING);
    removeSession(AUDIO_PLAYER.PLAY_ALL_AUDIO);
    removeSession(AUDIO_PLAYER.ADD_TO_QUEUE);
    removeSession(AUDIO_PLAYER.REMOVE_FROM_QUEUE);
    removeSession(AUDIO_PLAYER.CHANGE_PLAYING_STATE);
    removeSession(AUDIO_PLAYER.CHANGE_AUDIO_PLAY_STATE);
  }, [dispatch]);

  const handleFiveSecondsRewind = useCallback(() => {
    // Disable rewind for live audio
    if (currentAudio?.isLive) return;

    const newTime = Math.max(currentTime - 5, 0);
    dispatch(setCurrentAudioTime(newTime));

    // Directly update the audio element
    const audioElement = document.querySelector("audio.Thalplayer") as HTMLAudioElement | null;
    if (audioElement) {
      audioElement.currentTime = newTime;
    }
  }, [currentAudio?.isLive, currentTime, dispatch]);

  const handleFiveSecondsForward = useCallback(() => {
    // Disable forward for live audio
    if (currentAudio?.isLive) return;

    const newTime = Math.min(currentTime + 5, duration);
    dispatch(setCurrentAudioTime(newTime));

    // Directly update the audio element
    const audioElement = document.querySelector("audio.Thalplayer") as HTMLAudioElement | null;
    if (audioElement) {
      audioElement.currentTime = newTime;
    }
  }, [currentAudio?.isLive, currentTime, duration, dispatch]);

  const handleSliderChange = useCallback(
    (_event: Event, value: number | number[]) => {
      // Prevent slider change for live audio
      if (currentAudio?.isLive) return;

      _event.stopPropagation();
      const newValue = typeof value === "number" ? value : value[0];
      const newTime = (newValue / 100) * duration;

      // NEW: Set dragging state and store drag time
      setIsDragging(true);
      setDragTime(newTime);
      setHoverTime(newTime);
      setMobileTooltipTime(newTime);

      dispatch(setCurrentAudioTime(newTime));
      dispatch(setProgress(newValue));

      // Directly update the audio element
      const audioElement = document.querySelector("audio.Thalplayer") as HTMLAudioElement | null;
      if (audioElement) {
        audioElement.currentTime = newTime;
      }
    },
    [currentAudio?.isLive, duration, dispatch],
  );

  // NEW: Handle when slider drag ends
  const handleSliderChangeEnd = useCallback(() => {
    setIsDragging(false);
    if (isMobile) {
      dispatch(setCurrentAudioTime(mobileTooltipTime));
      // dispatch(setProgress(mobileTooltipTime));
    } else {
      dispatch(setCurrentAudioTime(hoverTime));
      // dispatch(setProgress(hoverTime));
    }
  }, [isMobile, mobileTooltipTime, hoverTime, dispatch]);

  const handleSliderHover = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (isMobile) return; // Only show tooltip on desktop
      e.stopPropagation();
      const containerRect = e.currentTarget.getBoundingClientRect();
      const x = e.clientX - containerRect.left;
      const percentage = Math.max(0, Math.min((x / containerRect.width) * 100, 100));
      const time = (percentage / 100) * duration;

      // Calculate tooltip position with bounds checking
      let tooltipPos = (containerRect.width * percentage) / 100;
      const tooltipWidth = 45; // Approximate tooltip width

      // Constrain tooltip to stay within container
      tooltipPos = Math.max(tooltipWidth / 2, Math.min(tooltipPos, containerRect.width - tooltipWidth / 2));

      setHoverTime(time);
      setTooltipX(tooltipPos);
      setShowHoverTooltip(true);
    },
    [isMobile, duration],
  );

  const handleSliderLeave = useCallback(() => {
    setShowHoverTooltip(false);
  }, []);

  const handleMobileSeekTouch = useCallback(
    (e: React.TouchEvent<HTMLDivElement>) => {
      if (!isMobile) return;
      e.stopPropagation();

      const touch = e.touches[0];
      const containerRect = e.currentTarget.getBoundingClientRect();
      const x = touch.clientX - containerRect.left;
      const percentage = Math.max(0, Math.min((x / containerRect.width) * 100, 100));
      const time = (percentage / 100) * duration;

      // Calculate tooltip position with bounds checking
      let tooltipPos = (containerRect.width * percentage) / 100;
      const tooltipWidth = 45; // Approximate tooltip width

      // Constrain tooltip to stay within container
      tooltipPos = Math.max(tooltipWidth / 2, Math.min(tooltipPos, containerRect.width - tooltipWidth / 2));

      // NEW: Set dragging state for mobile
      setIsDragging(true);
      setDragTime(time);
      setMobileTooltipTime(time);
      setMobileTooltipX(tooltipPos);
      setShowMobileSeekTooltip(true);
    },
    [isMobile, duration],
  );

  const handleMobileSeekTouchEnd = useCallback(() => {
    // NEW: End dragging on touch end
    setIsDragging(false);
    setShowMobileSeekTooltip(false);
  }, []);

  useEffect(() => {
    setShoeRemainingTime(duration === Infinity ? false : true);
  }, [currentAudio, duration]);

  useEffect(() => {
    dispatch(setDuration(duration));
  }, [playbackSpeed, dispatch, duration]);

  return (
    <div
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      className={cn(
        "relative w-full px-1 md:px-3 bg-secondaryBackground md:rounded-xl py-2 pb-3.5 2xl:pb-3 flex flex-col gap-0 md:gap-x-4 justify-between items-center cursor-pointer",
      )}
      style={{ touchAction: "none" }}
    >
      {showDeleteConfirmation ? (
        <div className="w-full flex flex-col justify-center items-center gap-2 px-4 mb-3">
          <span className={cn("text-textHeadingColor body_text_m font-inter font-medium w-full line-clamp-2 text-center", normalInter)}>
            Are you sure you want to close this audioPlayer?
          </span>
          <div className="w-full flex justify-center items-center gap-2">
            <div
              className="bg-menuBorderColor rounded-full flex justify-center items-center cursor-pointer px-3 py-0.5 border border-textHeadingColor"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleAudioPlayerCloseWithConfirmation();
              }}
              title="close"
            >
              <span className={cn("text-textHeadingColor body_text_xs font-normal font-inter", normalInter)}>Yes</span>
            </div>
            <div
              className=" bg-darkOrangeColor rounded-full flex justify-center items-center cursor-pointer px-3 py-0.5"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                dispatch(setShowDeleteConfirmation(false));
                dispatch(changeIsAudioPlayState(true));
                dispatch(changeIsPlayingState(true));
              }}
              title="keep play"
            >
              <span className={cn("text-white body_text_xs font-normal font-inter", normalInter)}>No</span>
            </div>
          </div>
        </div>
      ) : (
        <>
          {/* title and duration */}
          <div className="w-full flex justify-between items-center px-3 md:px-0 gap-x-2 pb-2 md:py-2">
            <div className="">
              <p
                title={currentAudio ? currentAudio.name : "No Name Available"}
                className={cn(
                  "xs:text-14 2xl:text-16 text-textHeadingColor font-medium capitalize text-nowrap overflow-hidden truncate line-clamp-1 xs:w-[180px] smd:w-[230px] 2xl:w-[250px] space-x-2",
                  normalInter,
                )}
              >
                <span>{currentAudio ? currentAudio.name : "No Name Available"}</span>
                {currentAudio?.isLive && (
                  <span className="border-1 border-borderPrimary px-1.5 rounded-lg bg-textHeadingColor body_text_xs text-white">Live</span>
                )}
              </p>

              {/* <span
                className={cn("body_text_xs 2xl:text-12 font-inter font-normal text-textSecondaryColor w-full line-clamp-1 ", normalInter)}
                title={currentAudio?.artist ?? "No Artist Available"}
              >
                {currentAudio ? currentAudio.artist : "No Artist Available"}
              </span> */}
            </div>

            <div className="w-full  md:w-[120px] text-end">
              {showRemainingTime && Number.isFinite(duration) && Number.isFinite(currentTime) && (
                <span className={cn("body_text_xs text-textSecondaryColor  mt-0.5 text-nowrap font-robotomono ")}>
                  {/* UPDATED: Show dragTime if dragging, otherwise show currentTime */}
                  {formatTime(isDragging ? dragTime : currentTime)} / {formatTime(duration)}
                </span>
              )}
            </div>
          </div>

          <div
            className="w-full flex justify-center md:px-0 px-3 gap-3 2xl:gap-3 2xl:justify-between items-center"
            style={{ touchAction: "manipulation" }}
            onClick={(e) => {
              e.stopPropagation();
              if (audioQueue && audioQueue.length > 0) dispatch(changeDesktopAccordionStatus(!desktopAccordionShow));
              // if (isMobile) dispatch(changeMobileDrawerStatus(!isMobileDrawerOpen));
            }}
          >
            <div className="rounded-full relative flex justify-center items-center gap-x-3" style={{ touchAction: "manipulation" }}>
              {media_type_control !== "music" && (
                <motion.button
                  initial="initial"
                  whileTap={"tap"}
                  variants={touchVariants}
                  className={cn("control-btn", currentAudio?.isLive ? "cursor-not-allowed opacity-50" : "")}
                  title={currentAudio?.isLive ? "Not available for live audio" : "5s rewind"}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleFiveSecondsRewind();
                  }}
                  style={{ touchAction: "manipulation" }}
                  disabled={currentAudio?.isLive}
                >
                  <RiReplay5Fill color={COLORS.iconOrange} size={20} />
                </motion.button>
              )}

              <motion.button
                initial="initial"
                whileTap={"tap"}
                variants={touchVariants}
                className={cn(
                  "control-btn",
                  audioQueue?.length === 1 || currentAudio?.isLive || !audioQueue || audioQueue.length === 0 ? "cursor-not-allowed opacity-50" : "",
                )}
                title={
                  currentAudio?.isLive
                    ? "Not available for live audio"
                    : audioQueue && audioQueue.length <= 1
                      ? "Only one item in queue"
                      : "play previous"
                }
                onClick={(e) => {
                  e.stopPropagation();
                  handlePreviousAudio();
                }}
                disabled={currentAudio?.isLive || audioQueue?.length === 1 || !audioQueue || audioQueue.length === 0}
              >
                <IoPlaySkipBack color={PLAY_PAUSE_ICON_COLOR} />
              </motion.button>

              {isPlaying ? (
                <div
                  className="cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    dispatch(changeIsPlayingState(false));
                    dispatch(onPauseVideo());
                    dispatch(setIsAnnakutAudioPlaying(false));
                    sessionStorage.setItem(AUDIO_PLAYER.IS_PLAY, JSON.stringify(false));
                  }}
                >
                  <FaPauseCircle size={isMobile ? 30 : 35} color={PLAY_PAUSE_ICON_COLOR} />
                </div>
              ) : (
                <div
                  className="cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    dispatch(changeIsPlayingState(true));
                    dispatch(onPauseVideo());
                    dispatch(setIsAnnakutAudioPlaying(true));
                    sessionStorage.setItem(AUDIO_PLAYER.IS_PLAY, JSON.stringify(true));
                  }}
                >
                  <FaPlayCircle size={isMobile ? 30 : 35} color={PLAY_PAUSE_ICON_COLOR} />
                </div>
              )}

              <motion.button
                initial="initial"
                whileTap={"tap"}
                variants={touchVariants}
                className={cn(
                  "control-btn",
                  audioQueue?.length === 1 || currentAudio?.isLive || !audioQueue || audioQueue.length === 0 ? "cursor-not-allowed opacity-50" : "",
                )}
                title={
                  currentAudio?.isLive
                    ? "Not available for live audio"
                    : audioQueue && audioQueue.length <= 1
                      ? "Only one item in queue"
                      : "Play next"
                }
                onClick={(e) => {
                  e.stopPropagation();
                  handleNextAudio();
                }}
                disabled={currentAudio?.isLive || audioQueue?.length === 1 || !audioQueue || audioQueue.length === 0}
              >
                <IoPlaySkipForward color={PLAY_PAUSE_ICON_COLOR} />
              </motion.button>

              {media_type_control !== "music" && (
                <motion.button
                  initial="initial"
                  whileTap={"tap"}
                  variants={touchVariants}
                  className={cn("control-btn", currentAudio?.isLive ? "cursor-not-allowed opacity-50" : "")}
                  title={currentAudio?.isLive ? "Not available for live audio" : "5s forward"}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleFiveSecondsForward();
                  }}
                  style={{ touchAction: "manipulation" }}
                  disabled={currentAudio?.isLive}
                >
                  <RiForward5Fill color={PLAY_PAUSE_ICON_COLOR} size={20} />
                </motion.button>
              )}
            </div>

            <div className="flex flex-col w-full md:flex-row items-center">
              <div className={cn("w-full flex items-center  gap-3", media_type_control !== "music" ? "justify-between" : "justify-end")}>
                {media_type_control !== "music" && (
                  <DropdownMenu modal={isMobile}>
                    <DropdownMenuTrigger
                      asChild
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      disabled={currentAudio?.isLive}
                    >
                      <Button
                        variant="outline"
                        className={cn(
                          "size-5 px-5 py-2.5 rounded-full bg-textHeadingColor border-[1px] border-borderPrimary hover:bg-textHeadingColor hover:text-white text-white",
                          currentAudio?.isLive ? "cursor-not-allowed opacity-50" : "",
                        )}
                        title={currentAudio?.isLive ? "Not available for live audio" : "playback speed"}
                        disabled={currentAudio?.isLive}
                      >
                        {playbackSpeed}x
                      </Button>
                    </DropdownMenuTrigger>
                    {!currentAudio?.isLive && (
                      <DropdownMenuContent className="w-20 bg-secondaryColor border-borderPrimary" side="bottom" align="center">
                        <DropdownMenuSeparator />
                        <DropdownMenuGroup>
                          {playBackSpeedArray.map((speed) => {
                            return (
                              <DropdownMenuItem
                                key={speed}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  dispatch(setPlaybackSpeed(speed));
                                }}
                                className={cn(
                                  "text-textColor hover:bg-chipHoverColor cursor-pointer font-inter font-medium",
                                  speed === playbackSpeed ? "bg-textHeadingColor text-white" : "",
                                )}
                              >
                                {speed}x
                              </DropdownMenuItem>
                            );
                          })}
                        </DropdownMenuGroup>
                      </DropdownMenuContent>
                    )}
                  </DropdownMenu>
                )}

                <div className="flex items-center justify-center gap-3">
                  {audioQueue && audioQueue.length > 0 ? (
                    <motion.button
                      initial="initial"
                      whileTap={"tap"}
                      variants={touchVariants}
                      className={cn("size-[25px] bg-white rounded-full flex justify-center items-center cursor-pointer")}
                      title="Collapse/Expand Queue"
                      onClick={(e) => {
                        e.stopPropagation();
                        // isMobile
                        //   ? dispatch(changeMobileDrawerStatus(!isMobileDrawerOpen))
                        //   :
                        dispatch(changeDesktopAccordionStatus(!desktopAccordionShow));
                      }}
                    >
                      {desktopAccordionShow ? (
                        <FaChevronDown color={COLORS.iconOrange} className="size-3 md:size-4" />
                      ) : (
                        <FaChevronUp color={COLORS.iconOrange} className="size-3 md:size-4" />
                      )}
                    </motion.button>
                  ) : null}

                  {!showDeleteConfirmation && (
                    <div
                      className={cn(
                        "bg-textHeadingColor rounded-full size-[20px] 2xl:size-[25px] flex items-center justify-center transition-all duration-200 ease-in-out",
                      )}
                      title="close"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleAudioPlayerClose();
                      }}
                    >
                      <IoClose color={COLORS.white} className=" size-3 md:size-4" />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Seek Bar - MUI Slider - Only render when not collapsed in mobile drawer */}
      {!showDeleteConfirmation && ((Number.isFinite(duration) && duration > 0) || currentAudio?.isLive) && (
        <div
          className={
            isMobile
              ? cn("fixed left-0 right-0 w-full px-0 ", isContent ? "bottom-[50px]" : "bottom-[59px]")
              : "absolute -top-[1.3rem] sm:-top-5 md:-top-5 lg:-top-3.5 2xl:-top-3.5 left-0 right-0 w-full px-1"
          }
        >
          <div
            className={cn(
              "w-full  md:px-0.5 flex justify-center items-center relative overflow-visible",
              currentAudio?.isLive ? "pl-1 pr-2" : "px-1",
            )}
            onMouseMove={(e) => {
              e.stopPropagation();
              handleSliderHover(e);
            }}
            onMouseLeave={(e) => {
              e.stopPropagation();
              handleSliderLeave();
            }}
            onMouseDown={(e) => e.stopPropagation()}
            onMouseUp={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
            onTouchMove={(e) => {
              e.stopPropagation();
              handleMobileSeekTouch(e);
            }}
            onTouchEnd={(e) => {
              e.stopPropagation();
              handleMobileSeekTouchEnd();
            }}
          >
            {showHoverTooltip && !isMobile && !currentAudio?.isLive && (
              <div
                className="absolute bg-textHeadingColor text-white text-xs font-medium px-2 py-1 rounded pointer-events-none whitespace-nowrap z-[9999]"
                style={{
                  left: `${tooltipX}px`,
                  bottom: "30px",
                  transform: "translateX(-50%)",
                }}
              >
                {/* UPDATED: Show dragTime if dragging, otherwise show hoverTime */}
                {formatTime(isDragging ? dragTime : hoverTime)}
              </div>
            )}

            {showMobileSeekTooltip && isMobile && !currentAudio?.isLive && (
              <div
                className="absolute bg-textHeadingColor text-white text-xs font-medium px-2 py-1 rounded pointer-events-none whitespace-nowrap z-[9999]"
                style={{
                  left: `${mobileTooltipX}px`,
                  bottom: "30px",
                  transform: "translateX(-50%)",
                }}
              >
                {formatTime(mobileTooltipTime)}
              </div>
            )}

            <Slider
              ref={sliderRef}
              size="small"
              min={0}
              max={100}
              value={currentAudio?.isLive ? 100 : progress || 0}
              onChange={handleSliderChange}
              onChangeCommitted={handleSliderChangeEnd}
              disabled={currentAudio?.isLive}
              sx={{
                width: "100%",
                color: currentAudio?.isLive ? ICON_ORANGE_COLOR : ICON_ORANGE_COLOR,
                height: 4,
                opacity: 1,
                "& .MuiSlider-track": {
                  backgroundColor: currentAudio?.isLive ? ICON_ORANGE_COLOR : ICON_ORANGE_COLOR,
                },
                "& .MuiSlider-rail": {
                  backgroundColor: currentAudio?.isLive ? ICON_ORANGE_COLOR : "rgba(0, 0, 0, 0.38)",
                },
                "& .MuiSlider-thumb": {
                  // display: isMobile ? "block" : "none",
                  display: "block",
                  width: 10,
                  height: 10,
                  backgroundColor: currentAudio?.isLive ? ICON_ORANGE_COLOR : ICON_ORANGE_COLOR,
                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  zIndex: 61,
                },
                "& .MuiSlider-rail:hover ~ .MuiSlider-thumb": {
                  // display: isMobile ? "block" : "block",
                  display: "block",
                },

                "&:hover .MuiSlider-thumb": {
                  display: "block",
                },
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default memo(AudioPlayerPopUp);
